function getGradientColorStops(colors) {
    var stops = "";
    for(var i = 1; i < colors.length - 1; i += 1){
        stops += "".concat(colors[i], " ").concat(i / (colors.length - 1) * 100, "%, ");
    }
    return "".concat(colors[0], " 0%, ").concat(stops).concat(colors[colors.length - 1], " 100%");
}
export { getGradientColorStops }; //# sourceMappingURL=get-gradient-color-stops.js.map
